import React, { useMemo } from 'react';
import { Platform, SectionList } from 'react-native';
import moment from 'moment';
import { createStyleSheet } from '../../utils';
import { useStyleSheet } from '../../hooks';
import { Message } from '../Message';
import { View } from '../View';
import { Placeholder, Fallback, Header } from './components';
export const Messages = (props) => {
    const styles = useStyleSheet(getStyles);
    const isEmpty = props.isLoading !== true && !props.data.length;
    const condensed = useMemo(() => {
        if (props.isLoading)
            return [];
        return props.data.reduce((acc, message) => {
            const prev = acc[acc.length - 1];
            if (!prev ||
                message.author !== prev.author ||
                !moment(message.createdAt).isSame(prev.date, 'day') ||
                !(moment(prev.date).diff(message.createdAt, 'minutes') <= 10))
                return [
                    ...acc,
                    { date: message.createdAt, author: message.author, data: [message] }
                ];
            prev.data.unshift(message);
            prev.date = message.createdAt;
            return acc;
        }, []);
    }, [props.data, props.isLoading]);
    const sections = useMemo(() => {
        return condensed.reduce((acc, message) => {
            if (!acc.length ||
                !moment(acc[acc.length - 1].date).isSame(message.date, 'day'))
                return [...acc, { date: message.date, data: [message] }];
            acc[acc.length - 1].data.push(message);
            return acc;
        }, []);
    }, [condensed]);
    return (React.createElement(View, { style: styles.container }, props.isLoading ? (React.createElement(Placeholder, null)) : isEmpty ? (React.createElement(Fallback, Object.assign({ participants: props.participants, viewProfile: props.viewProfile }, (props.templates !== undefined
        ? {
            templates: props.templates,
            onTemplateSend: props.onTemplateSend
        }
        : { templates: undefined })))) : (React.createElement(SectionList, { contentContainerStyle: styles.contentContainer, sections: sections, renderItem: ({ item }) => {
            var _a;
            return (React.createElement(Message, { time: item.date, data: item.data, author: (_a = props.participants.find(({ id }) => id === item.author)) !== null && _a !== void 0 ? _a : {}, onAppointmentPreview: props.onAppointmentPreview, onFilePreview: props.onFilePreview, onFileDownload: props.onFileDownload, customMessageRenderers: props.customMessageRenderers }));
        }, renderSectionFooter: ({ section: { date } }) => (React.createElement(Header, { date: date })), keyExtractor: (item) => item.date, inverted: true, onEndReached: props.onEndReached, onEndReachedThreshold: 2, disableVirtualization: true }))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: Object.assign(Object.assign({ flex: 1 }, Platform.select({ web: { overflowY: 'auto' }, ios: {}, android: {} })), { width: Platform.OS === 'web' ? `calc(100% + ${size.F * 2}px)` : '100%', marginLeft: -size.F }),
    contentContainer: {
        paddingLeft: size.K - size.E,
        paddingRight: size.K - size.F,
        paddingTop: size.C
    }
}));
//# sourceMappingURL=index.js.map